import Auth from "./pages/Auth";
import AuthSignoutComponent from "./components/AuthSignOut";
export default Auth;
export { useAuthFeature } from "./hooks";
export { authConfig } from "./config";
export type { UserInfo } from "./models";
export const AuthSignout = AuthSignoutComponent;
